import React from 'react';
import {Routes , Route } from 'react-router-dom';
import Catalogue from '../Pages/Catalogue';
import Services from '../Pages/Services';
import About from '../Pages/About';
import NotFoundPage from '../Pages/404';
import Home from '../Pages/Home';
import Contact from '../Pages/Contact';
import Qr from '../Pages/Qr';

export default function Router() {
  
    return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/catalogue" element={<Catalogue />} />
        <Route path="/:orderId" element={<Qr />} />
        <Route path="/contacts" element={<Contact />} />
        <Route path="*" element={<NotFoundPage />} />

      </Routes>
    );
  }; 



